export class Feedback {
  public description: string;
  public screenshot: string;
}
